import { formatPercent } from "@/features/matches";

import type { FriendsMetric } from "./FRIENDS_METRICS";

export const formatNumber = (value: number, locale: string, digits = 0): string =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

// Значение показателя на языке интерфейса; нет значения — «—». Ранг подписывается
// названием из справочника там, где известен `rank_badge`, здесь — только числа.
export const formatMetric = (
  metric: FriendsMetric,
  value: number | null,
  locale: string,
): string => {
  if (value === null) {
    return "—";
  }
  switch (metric) {
    case "winRate":
      return formatPercent(value, locale);
    case "kda":
    case "deaths":
      return formatNumber(value, locale, 1);
    case "score":
    case "soulsPerMinute":
    case "matches":
    case "rank":
      return formatNumber(value, locale);
  }
};
